export default __webpack_public_path__ + "static/media/Group 3024@2x.4bc0e0d0.png";